var k = Object.defineProperty;
var y = (e, t, n) => t in e ? k(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n;
var c = (e, t, n) => (y(e, typeof t != "symbol" ? t + "" : t, n), n);
const b = "https://tbd.ag.ch/api/v1".replace(/\/+$/, "");
class I {
  constructor(t = {}) {
    this.configuration = t;
  }
  set config(t) {
    this.configuration = t;
  }
  get basePath() {
    return this.configuration.basePath != null ? this.configuration.basePath : b;
  }
  get fetchApi() {
    return this.configuration.fetchApi;
  }
  get middleware() {
    return this.configuration.middleware || [];
  }
  get queryParamsStringify() {
    return this.configuration.queryParamsStringify || m;
  }
  get username() {
    return this.configuration.username;
  }
  get password() {
    return this.configuration.password;
  }
  get apiKey() {
    const t = this.configuration.apiKey;
    if (t)
      return typeof t == "function" ? t : () => t;
  }
  get accessToken() {
    const t = this.configuration.accessToken;
    if (t)
      return typeof t == "function" ? t : async () => t;
  }
  get headers() {
    return this.configuration.headers;
  }
  get credentials() {
    return this.configuration.credentials;
  }
}
const S = new I();
class h {
  constructor(t = S) {
    c(this, "middleware");
    c(this, "fetchApi", async (t, n) => {
      let i = { url: t, init: n };
      for (const a of this.middleware)
        a.pre && (i = await a.pre({
          fetch: this.fetchApi,
          ...i
        }) || i);
      let r;
      try {
        r = await (this.configuration.fetchApi || fetch)(i.url, i.init);
      } catch (a) {
        for (const l of this.middleware)
          l.onError && (r = await l.onError({
            fetch: this.fetchApi,
            url: i.url,
            init: i.init,
            error: a,
            response: r ? r.clone() : void 0
          }) || r);
        if (r === void 0)
          throw a instanceof Error ? new N(a, "The request failed and the interceptors did not return an alternative response") : a;
      }
      for (const a of this.middleware)
        a.post && (r = await a.post({
          fetch: this.fetchApi,
          url: i.url,
          init: i.init,
          response: r.clone()
        }) || r);
      return r;
    });
    this.configuration = t, this.middleware = t.middleware;
  }
  withMiddleware(...t) {
    const n = this.clone();
    return n.middleware = n.middleware.concat(...t), n;
  }
  withPreMiddleware(...t) {
    const n = t.map((i) => ({ pre: i }));
    return this.withMiddleware(...n);
  }
  withPostMiddleware(...t) {
    const n = t.map((i) => ({ post: i }));
    return this.withMiddleware(...n);
  }
  async request(t, n) {
    const { url: i, init: r } = await this.createFetchParams(t, n), a = await this.fetchApi(i, r);
    if (a && a.status >= 200 && a.status < 300)
      return a;
    throw new O(a, "Response returned an error code");
  }
  async createFetchParams(t, n) {
    let i = this.configuration.basePath + t.path;
    t.query !== void 0 && Object.keys(t.query).length !== 0 && (i += "?" + this.configuration.queryParamsStringify(t.query));
    const r = Object.assign({}, this.configuration.headers, t.headers);
    Object.keys(r).forEach((p) => r[p] === void 0 ? delete r[p] : {});
    const a = typeof n == "function" ? n : async () => n, l = {
      method: t.method,
      headers: r,
      body: t.body,
      credentials: this.configuration.credentials
    }, u = {
      ...l,
      ...await a({
        init: l,
        context: t
      })
    }, q = {
      ...u,
      body: P(u.body) || u.body instanceof URLSearchParams || T(u.body) ? u.body : JSON.stringify(u.body)
    };
    return { url: i, init: q };
  }
  /**
   * Create a shallow clone of `this` by constructing a new instance
   * and then shallow cloning data members.
   */
  clone() {
    const t = this.constructor, n = new t(this.configuration);
    return n.middleware = this.middleware.slice(), n;
  }
}
function T(e) {
  return typeof Blob < "u" && e instanceof Blob;
}
function P(e) {
  return typeof FormData < "u" && e instanceof FormData;
}
class O extends Error {
  constructor(n, i) {
    super(i);
    c(this, "name", "ResponseError");
    this.response = n;
  }
}
class N extends Error {
  constructor(n, i) {
    super(i);
    c(this, "name", "FetchError");
    this.cause = n;
  }
}
class o extends Error {
  constructor(n, i) {
    super(i);
    c(this, "name", "RequiredError");
    this.field = n;
  }
}
const V = {
  csv: ",",
  ssv: " ",
  tsv: "	",
  pipes: "|"
};
function s(e, t) {
  const n = e[t];
  return n != null;
}
function m(e, t = "") {
  return Object.keys(e).map((n) => w(n, e[n], t)).filter((n) => n.length > 0).join("&");
}
function w(e, t, n = "") {
  const i = n + (n.length ? `[${e}]` : e);
  if (t instanceof Array) {
    const r = t.map((a) => encodeURIComponent(String(a))).join(`&${encodeURIComponent(i)}=`);
    return `${encodeURIComponent(i)}=${r}`;
  }
  if (t instanceof Set) {
    const r = Array.from(t);
    return w(e, r, n);
  }
  return t instanceof Date ? `${encodeURIComponent(i)}=${encodeURIComponent(t.toISOString())}` : t instanceof Object ? m(t, i) : `${encodeURIComponent(i)}=${encodeURIComponent(String(t))}`;
}
function _(e, t) {
  return Object.keys(e).reduce(
    (n, i) => ({ ...n, [i]: t(e[i]) }),
    {}
  );
}
function z(e) {
  for (const t of e)
    if (t.contentType === "multipart/form-data")
      return !0;
  return !1;
}
class f {
  constructor(t, n = (i) => i) {
    this.raw = t, this.transformer = n;
  }
  async value() {
    return this.transformer(await this.raw.json());
  }
}
class d {
  constructor(t) {
    this.raw = t;
  }
  async value() {
  }
}
class Q {
  constructor(t) {
    this.raw = t;
  }
  async value() {
    return await this.raw.blob();
  }
}
class W {
  constructor(t) {
    this.raw = t;
  }
  async value() {
    return await this.raw.text();
  }
}
function X(e) {
  let t = !0;
  return t = t && "reason" in e, t = t && "email" in e, t = t && "captcha" in e, t;
}
function Y(e) {
  return C(e);
}
function C(e, t) {
  return e == null ? e : {
    reason: e.reason,
    comment: s(e, "comment") ? e.comment : void 0,
    email: e.email,
    captcha: e.captcha
  };
}
function F(e) {
  if (e !== void 0)
    return e === null ? null : {
      reason: e.reason,
      comment: e.comment,
      email: e.email,
      captcha: e.captcha
    };
}
const j = {
  Frau: "Frau",
  Herr: "Herr",
  Divers: "Divers",
  KeineAngabe: "Keine Angabe"
};
function ee(e) {
  let t = !0;
  return t = t && "captcha" in e, t;
}
function te(e) {
  return A(e);
}
function A(e, t) {
  return e == null ? e : {
    captcha: e.captcha,
    email: s(e, "email") ? e.email : void 0,
    salutation: s(e, "salutation") ? e.salutation : void 0,
    firstname: s(e, "firstname") ? e.firstname : void 0,
    lastname: s(e, "lastname") ? e.lastname : void 0,
    bksakTheaterfunken: s(e, "bksakTheaterfunken") ? e.bksakTheaterfunken : void 0,
    bksakZielgruppe: s(e, "bksakZielgruppe") ? e.bksakZielgruppe : void 0
  };
}
function v(e) {
  if (e !== void 0)
    return e === null ? null : {
      captcha: e.captcha,
      email: e.email,
      salutation: e.salutation,
      firstname: e.firstname,
      lastname: e.lastname,
      bksakTheaterfunken: e.bksakTheaterfunken,
      bksakZielgruppe: e.bksakZielgruppe
    };
}
function ne(e) {
  return !0;
}
function J(e) {
  return E(e);
}
function E(e, t) {
  return e == null ? e : {
    html: s(e, "html") ? e.html : void 0
  };
}
function ie(e) {
  if (e !== void 0)
    return e === null ? null : {
      html: e.html
    };
}
function re(e) {
  let t = !0;
  return t = t && "id" in e, t = t && "name" in e, t = t && "description" in e, t = t && "link" in e, t;
}
function g(e) {
  return D(e);
}
function D(e, t) {
  return e == null ? e : {
    id: e.id,
    name: e.name,
    description: e.description,
    link: e.link
  };
}
function Z(e) {
  if (e !== void 0)
    return e === null ? null : {
      id: e.id,
      name: e.name,
      description: e.description,
      link: e.link
    };
}
const ae = {
  Frau: "Frau",
  Herr: "Herr",
  Divers: "Divers",
  KeineAngabe: "Keine Angabe"
};
function se(e) {
  return !0;
}
function U(e) {
  return M(e);
}
function M(e, t) {
  return e == null ? e : {
    newsletters: s(e, "newsletters") ? e.newsletters.map(g) : void 0,
    email: s(e, "email") ? e.email : void 0,
    salutation: s(e, "salutation") ? e.salutation : void 0,
    firstname: s(e, "firstname") ? e.firstname : void 0,
    lastname: s(e, "lastname") ? e.lastname : void 0,
    bksakTheaterfunken: s(e, "bksakTheaterfunken") ? e.bksakTheaterfunken : void 0,
    bksakZielgruppe: s(e, "bksakZielgruppe") ? e.bksakZielgruppe : void 0
  };
}
function oe(e) {
  if (e !== void 0)
    return e === null ? null : {
      newsletters: e.newsletters === void 0 ? void 0 : e.newsletters.map(Z),
      email: e.email,
      salutation: e.salutation,
      firstname: e.firstname,
      lastname: e.lastname,
      bksakTheaterfunken: e.bksakTheaterfunken,
      bksakZielgruppe: e.bksakZielgruppe
    };
}
function le(e) {
  let t = !0;
  return t = t && "mailingId" in e, t = t && "title" in e, t = t && "date" in e, t = t && "description" in e, t;
}
function $(e) {
  return G(e);
}
function G(e, t) {
  return e == null ? e : {
    mailingId: e.mailingId,
    title: e.title,
    date: e.date,
    description: e.description
  };
}
function ue(e) {
  if (e !== void 0)
    return e === null ? null : {
      mailingId: e.mailingId,
      title: e.title,
      date: e.date,
      description: e.description
    };
}
function ce(e) {
  let t = !0;
  return t = t && "email" in e, t = t && "captcha" in e, t;
}
function de(e) {
  return K(e);
}
function K(e, t) {
  return e == null ? e : {
    email: e.email,
    captcha: e.captcha
  };
}
function R(e) {
  if (e !== void 0)
    return e === null ? null : {
      email: e.email,
      captcha: e.captcha
    };
}
const fe = {
  Frau: "Frau",
  Herr: "Herr",
  Divers: "Divers",
  KeineAngabe: "Keine Angabe"
};
function he(e) {
  let t = !0;
  return t = t && "newsletterIds" in e, t = t && "captcha" in e, t = t && "email" in e, t = t && "salutation" in e, t = t && "firstname" in e, t = t && "lastname" in e, t;
}
function pe(e) {
  return L(e);
}
function L(e, t) {
  return e == null ? e : {
    newsletterIds: e.newsletterIds,
    captcha: e.captcha,
    email: e.email,
    salutation: e.salutation,
    firstname: e.firstname,
    lastname: e.lastname,
    bksakTheaterfunken: s(e, "bksakTheaterfunken") ? e.bksakTheaterfunken : void 0,
    bksakZielgruppe: s(e, "bksakZielgruppe") ? e.bksakZielgruppe : void 0
  };
}
function H(e) {
  if (e !== void 0)
    return e === null ? null : {
      newsletterIds: e.newsletterIds,
      captcha: e.captcha,
      email: e.email,
      salutation: e.salutation,
      firstname: e.firstname,
      lastname: e.lastname,
      bksakTheaterfunken: e.bksakTheaterfunken,
      bksakZielgruppe: e.bksakZielgruppe
    };
}
const me = {
  Frau: "Frau",
  Herr: "Herr",
  Divers: "Divers",
  KeineAngabe: "Keine Angabe"
};
function we(e) {
  return !0;
}
function ge(e) {
  return B(e);
}
function B(e, t) {
  return e == null ? e : {
    email: s(e, "email") ? e.email : void 0,
    salutation: s(e, "salutation") ? e.salutation : void 0,
    firstname: s(e, "firstname") ? e.firstname : void 0,
    lastname: s(e, "lastname") ? e.lastname : void 0,
    bksakTheaterfunken: s(e, "bksakTheaterfunken") ? e.bksakTheaterfunken : void 0,
    bksakZielgruppe: s(e, "bksakZielgruppe") ? e.bksakZielgruppe : void 0
  };
}
function Re(e) {
  if (e !== void 0)
    return e === null ? null : {
      email: e.email,
      salutation: e.salutation,
      firstname: e.firstname,
      lastname: e.lastname,
      bksakTheaterfunken: e.bksakTheaterfunken,
      bksakZielgruppe: e.bksakZielgruppe
    };
}
class qe extends h {
  /**
   * Endpoint for handling the cancellation reason for a single newsletter.
   * Report cancellation reason
   */
  async cancellationReasonRaw(t, n) {
    if (t.listId === null || t.listId === void 0)
      throw new o("listId", "Required parameter requestParameters.listId was null or undefined when calling cancellationReason.");
    if (t.cancellationReasonRequest === null || t.cancellationReasonRequest === void 0)
      throw new o("cancellationReasonRequest", "Required parameter requestParameters.cancellationReasonRequest was null or undefined when calling cancellationReason.");
    const i = {}, r = {};
    r["Content-Type"] = "application/json";
    const a = await this.request({
      path: "/lists/{listId}/cancellation-reason".replace("{listId}", encodeURIComponent(String(t.listId))),
      method: "POST",
      headers: r,
      query: i,
      body: F(t.cancellationReasonRequest)
    }, n);
    return new d(a);
  }
  /**
   * Endpoint for handling the cancellation reason for a single newsletter.
   * Report cancellation reason
   */
  async cancellationReason(t, n, i) {
    await this.cancellationReasonRaw({ listId: t, cancellationReasonRequest: n }, i);
  }
  /**
   * Cancellation for a user and an Inxmail list item. User information is in the hash.
   * Direct cancellation
   */
  async directCancellationRaw(t, n) {
    if (t.listId === null || t.listId === void 0)
      throw new o("listId", "Required parameter requestParameters.listId was null or undefined when calling directCancellation.");
    if (t.hash === null || t.hash === void 0)
      throw new o("hash", "Required parameter requestParameters.hash was null or undefined when calling directCancellation.");
    const i = {};
    t.hash !== void 0 && (i.hash = t.hash);
    const r = {}, a = await this.request({
      path: "/lists/{listId}/direct-cancellation".replace("{listId}", encodeURIComponent(String(t.listId))),
      method: "POST",
      headers: r,
      query: i
    }, n);
    return new d(a);
  }
  /**
   * Cancellation for a user and an Inxmail list item. User information is in the hash.
   * Direct cancellation
   */
  async directCancellation(t, n, i) {
    await this.directCancellationRaw({ listId: t, hash: n }, i);
  }
  /**
   * Triggers an email in which the cancellation can be confirmed.
   * Initiate cancellation process
   */
  async requestCancellationRaw(t, n) {
    if (t.listId === null || t.listId === void 0)
      throw new o("listId", "Required parameter requestParameters.listId was null or undefined when calling requestCancellation.");
    if (t.requestProfileRequest === null || t.requestProfileRequest === void 0)
      throw new o("requestProfileRequest", "Required parameter requestParameters.requestProfileRequest was null or undefined when calling requestCancellation.");
    const i = {}, r = {};
    r["Content-Type"] = "application/json";
    const a = await this.request({
      path: "/lists/{listId}/request-cancellation".replace("{listId}", encodeURIComponent(String(t.listId))),
      method: "POST",
      headers: r,
      query: i,
      body: R(t.requestProfileRequest)
    }, n);
    return new d(a);
  }
  /**
   * Triggers an email in which the cancellation can be confirmed.
   * Initiate cancellation process
   */
  async requestCancellation(t, n, i) {
    await this.requestCancellationRaw({ listId: t, requestProfileRequest: n }, i);
  }
}
class ke extends h {
  /**
   * Returns the latest newsletter issues.
   * Returns latest newsletters
   */
  async getLatestNewslettersRaw(t, n) {
    if (t.listId === null || t.listId === void 0)
      throw new o("listId", "Required parameter requestParameters.listId was null or undefined when calling getLatestNewsletters.");
    const i = {};
    t.count !== void 0 && (i.count = t.count);
    const r = {}, a = await this.request({
      path: "/lists/{listId}/latest".replace("{listId}", encodeURIComponent(String(t.listId))),
      method: "GET",
      headers: r,
      query: i
    }, n);
    return new f(a, (l) => l.map($));
  }
  /**
   * Returns the latest newsletter issues.
   * Returns latest newsletters
   */
  async getLatestNewsletters(t, n, i) {
    return await (await this.getLatestNewslettersRaw({ listId: t, count: n }, i)).value();
  }
  /**
   * Returns the complete html of an Inxmail mailing.
   * Returns content of a Newsletter
   */
  async getMailingContentRaw(t, n) {
    if (t.mailingId === null || t.mailingId === void 0)
      throw new o("mailingId", "Required parameter requestParameters.mailingId was null or undefined when calling getMailingContent.");
    const i = {}, r = {}, a = await this.request({
      path: "/mailings/{mailingId}/content".replace("{mailingId}", encodeURIComponent(String(t.mailingId))),
      method: "GET",
      headers: r,
      query: i
    }, n);
    return new f(a, (l) => J(l));
  }
  /**
   * Returns the complete html of an Inxmail mailing.
   * Returns content of a Newsletter
   */
  async getMailingContent(t, n) {
    return await (await this.getMailingContentRaw({ mailingId: t }, n)).value();
  }
  /**
   * Returns all relevant newsletters.
   * Returns all newsletters
   */
  async getNewslettersRaw(t) {
    const n = {}, i = {}, r = await this.request({
      path: "/lists",
      method: "GET",
      headers: i,
      query: n
    }, t);
    return new f(r, (a) => a.map(g));
  }
  /**
   * Returns all relevant newsletters.
   * Returns all newsletters
   */
  async getNewsletters(t) {
    return await (await this.getNewslettersRaw(t)).value();
  }
}
class ye extends h {
  /**
   * Edits a user profile.
   * Edit profile
   */
  async editProfileRaw(t, n) {
    if (t.hash === null || t.hash === void 0)
      throw new o("hash", "Required parameter requestParameters.hash was null or undefined when calling editProfile.");
    if (t.editProfileRequest === null || t.editProfileRequest === void 0)
      throw new o("editProfileRequest", "Required parameter requestParameters.editProfileRequest was null or undefined when calling editProfile.");
    const i = {};
    t.hash !== void 0 && (i.hash = t.hash);
    const r = {};
    r["Content-Type"] = "application/json";
    const a = await this.request({
      path: "/profile/edit",
      method: "POST",
      headers: r,
      query: i,
      body: v(t.editProfileRequest)
    }, n);
    return new d(a);
  }
  /**
   * Edits a user profile.
   * Edit profile
   */
  async editProfile(t, n, i) {
    await this.editProfileRaw({ hash: t, editProfileRequest: n }, i);
  }
  /**
   * Returns all the information of a user profile.
   * Request profile
   */
  async getProfileRaw(t, n) {
    if (t.hash === null || t.hash === void 0)
      throw new o("hash", "Required parameter requestParameters.hash was null or undefined when calling getProfile.");
    const i = {};
    t.hash !== void 0 && (i.hash = t.hash);
    const r = {}, a = await this.request({
      path: "/profile",
      method: "GET",
      headers: r,
      query: i
    }, n);
    return new f(a, (l) => U(l));
  }
  /**
   * Returns all the information of a user profile.
   * Request profile
   */
  async getProfile(t, n) {
    return await (await this.getProfileRaw({ hash: t }, n)).value();
  }
  /**
   * Triggers an email to the user containing a link to the profile.
   * Request profile email
   */
  async requestProfileRaw(t, n) {
    if (t.requestProfileRequest === null || t.requestProfileRequest === void 0)
      throw new o("requestProfileRequest", "Required parameter requestParameters.requestProfileRequest was null or undefined when calling requestProfile.");
    const i = {}, r = {};
    r["Content-Type"] = "application/json";
    const a = await this.request({
      path: "/profile/request-link",
      method: "POST",
      headers: r,
      query: i,
      body: R(t.requestProfileRequest)
    }, n);
    return new d(a);
  }
  /**
   * Triggers an email to the user containing a link to the profile.
   * Request profile email
   */
  async requestProfile(t, n) {
    await this.requestProfileRaw({ requestProfileRequest: t }, n);
  }
}
class be extends h {
  /**
   * Triggers an email to the user containing a link to confirm the subscription(s).
   * Request confirmation email
   */
  async requestSubscriptionRaw(t, n) {
    if (t.requestSubscriptionRequest === null || t.requestSubscriptionRequest === void 0)
      throw new o("requestSubscriptionRequest", "Required parameter requestParameters.requestSubscriptionRequest was null or undefined when calling requestSubscription.");
    const i = {}, r = {};
    r["Content-Type"] = "application/json";
    const a = await this.request({
      path: "/subscription/request-link",
      method: "POST",
      headers: r,
      query: i,
      body: H(t.requestSubscriptionRequest)
    }, n);
    return new d(a);
  }
  /**
   * Triggers an email to the user containing a link to confirm the subscription(s).
   * Request confirmation email
   */
  async requestSubscription(t, n) {
    await this.requestSubscriptionRaw({ requestSubscriptionRequest: t }, n);
  }
}
export {
  b as BASE_PATH,
  h as BaseAPI,
  Q as BlobApiResponse,
  V as COLLECTION_FORMATS,
  qe as CancellationApi,
  Y as CancellationReasonRequestFromJSON,
  C as CancellationReasonRequestFromJSONTyped,
  F as CancellationReasonRequestToJSON,
  I as Configuration,
  S as DefaultConfig,
  te as EditProfileRequestFromJSON,
  A as EditProfileRequestFromJSONTyped,
  j as EditProfileRequestSalutationEnum,
  v as EditProfileRequestToJSON,
  N as FetchError,
  J as GetMailingContent200ResponseFromJSON,
  E as GetMailingContent200ResponseFromJSONTyped,
  ie as GetMailingContent200ResponseToJSON,
  U as GetProfile200ResponseFromJSON,
  M as GetProfile200ResponseFromJSONTyped,
  ae as GetProfile200ResponseSalutationEnum,
  oe as GetProfile200ResponseToJSON,
  f as JSONApiResponse,
  $ as LatestNewsletterFromJSON,
  G as LatestNewsletterFromJSONTyped,
  ue as LatestNewsletterToJSON,
  ke as NewsletterApi,
  g as NewsletterFromJSON,
  D as NewsletterFromJSONTyped,
  Z as NewsletterToJSON,
  ye as ProfileApi,
  de as RequestProfileRequestFromJSON,
  K as RequestProfileRequestFromJSONTyped,
  R as RequestProfileRequestToJSON,
  pe as RequestSubscriptionRequestFromJSON,
  L as RequestSubscriptionRequestFromJSONTyped,
  fe as RequestSubscriptionRequestSalutationEnum,
  H as RequestSubscriptionRequestToJSON,
  o as RequiredError,
  O as ResponseError,
  be as SubscriptionApi,
  W as TextApiResponse,
  ge as UserFromJSON,
  B as UserFromJSONTyped,
  me as UserSalutationEnum,
  Re as UserToJSON,
  d as VoidApiResponse,
  z as canConsumeForm,
  s as exists,
  X as instanceOfCancellationReasonRequest,
  ee as instanceOfEditProfileRequest,
  ne as instanceOfGetMailingContent200Response,
  se as instanceOfGetProfile200Response,
  le as instanceOfLatestNewsletter,
  re as instanceOfNewsletter,
  ce as instanceOfRequestProfileRequest,
  he as instanceOfRequestSubscriptionRequest,
  we as instanceOfUser,
  _ as mapValues,
  m as querystring
};
